import { useIntl } from '@/i18n';
import { Button, Result, Space } from 'antd';
import { withBasename } from './basename';

/**
 * 权限拉取失败（**不是 401**：断网 / 5xx / 代理没起）时的兜底页。
 *
 * 单独一页而不是白屏或直接跳登录页：401 有专门的分支（`http.ts` 会跳登录），
 * 走到这里的都是"会话可能还好着、只是这一次请求没成"的情形——把人踢回登录页
 * 会让他以为自己被登出了，而重新登录并不能解决断网。
 */
export default function AuthGuardFallback({
  onRetry,
}: {
  onRetry: () => void;
}) {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });

  return (
    <Result
      status="warning"
      title={t('auth.permLoadFailed')}
      subTitle={t('auth.permLoadFailedTip')}
      extra={
        <Space>
          <Button type="primary" onClick={onRetry}>
            {t('common.retry')}
          </Button>
          <Button onClick={() => (window.location.href = withBasename('/login'))}>
            {t('auth.backToLogin')}
          </Button>
        </Space>
      }
    />
  );
}
